export const CATEGORY_ICONS = [
    { value: 'CoffeeOutlined', label: '☕', search: 'coffee drink cafe' },
    { value: 'ShoppingCartOutlined', label: '🛒', search: 'shopping cart store buy' },
    { value: 'HomeOutlined', label: '🏠', search: 'home house housing rent' },
    { value: 'CarOutlined', label: '🚗', search: 'car vehicle transport' },
    { value: 'MedicineBoxOutlined', label: '💊', search: 'medicine healthcare medical health' },
    { value: 'BookOutlined', label: '📚', search: 'book education study learn' },
    { value: 'GiftOutlined', label: '🎁', search: 'gift present' },
    { value: 'ThunderboltOutlined', label: '⚡', search: 'utilities electric power energy' },
    { value: 'PhoneOutlined', label: '📱', search: 'phone mobile cell' },
    { value: 'DollarOutlined', label: '💵', search: 'money dollar cash' },
    { value: 'CreditCardOutlined', label: '💳', search: 'credit card payment' },
    { value: 'BankOutlined', label: '🏦', search: 'bank finance' },
    { value: 'WalletOutlined', label: '👛', search: 'wallet purse' },
    { value: 'ShopOutlined', label: '🏪', search: 'shop store retail' },
    { value: 'RestOutlined', label: '🍽️', search: 'restaurant food dining eat' },
    { value: 'EnvironmentOutlined', label: '📍', search: 'location place map' },
    { value: 'HeartOutlined', label: '❤️', search: 'heart health love' },
    { value: 'SmileOutlined', label: '😊', search: 'smile entertainment fun happy' },
    { value: 'TrophyOutlined', label: '🏆', search: 'trophy achievement award' },
    { value: 'RocketOutlined', label: '🚀', search: 'rocket travel trip vacation' },
    { value: 'ToolOutlined', label: '🔧', search: 'tool repair fix' },
    { value: 'BulbOutlined', label: '💡', search: 'bulb idea light' },
    { value: 'FireOutlined', label: '🔥', search: 'fire energy hot' },
    { value: 'CloudOutlined', label: '☁️', search: 'cloud weather' },
    { value: 'SafetyOutlined', label: '🛡️', search: 'safety insurance protect' },
    { value: 'LockOutlined', label: '🔒', search: 'lock security safe' },
    { value: 'KeyOutlined', label: '🔑', search: 'key access' },
    { value: 'SettingOutlined', label: '⚙️', search: 'setting config gear' },
    { value: 'ApiOutlined', label: '🔗', search: 'api service link' },
    { value: 'WifiOutlined', label: '📶', search: 'wifi internet network' },
    { value: 'SkinOutlined', label: '👕', search: 'clothing clothes fashion' },
    { value: 'ScissorOutlined', label: '✂️', search: 'scissor haircut salon' },
    { value: 'CameraOutlined', label: '📷', search: 'camera photo photography' },
    { value: 'VideoCameraOutlined', label: '🎥', search: 'video camera film' },
    { value: 'CustomerServiceOutlined', label: '🎧', search: 'music audio headphone' },
    { value: 'ReadOutlined', label: '📖', search: 'read book reading' },
    { value: 'ExperimentOutlined', label: '🧪', search: 'experiment science lab' },
    { value: 'MedicineBoxFilled', label: '⚕️', search: 'medical doctor hospital' },
    { value: 'HeartFilled', label: '💗', search: 'heart favorite love' },
    { value: 'StarOutlined', label: '⭐', search: 'star favorite rating' },
    { value: 'ThunderboltFilled', label: '⚡', search: 'power electric energy' },
    { value: 'CrownOutlined', label: '👑', search: 'crown premium vip' },
    { value: 'TrophyFilled', label: '🏅', search: 'medal trophy award' },
    { value: 'GoldOutlined', label: '🥇', search: 'gold medal first' },
    { value: 'DollarCircleOutlined', label: '💰', search: 'savings money dollar' },
    { value: 'EuroCircleOutlined', label: '💶', search: 'euro money currency' },
    { value: 'PoundCircleOutlined', label: '💷', search: 'pound money currency' },
    { value: 'TagOutlined', label: '🏷️', search: 'tag label price' },
    { value: 'TagsOutlined', label: '🏷️', search: 'tags labels' },
    { value: 'FundOutlined', label: '📊', search: 'fund investment chart' },
    { value: 'PieChartOutlined', label: '📈', search: 'pie chart graph' },
    { value: 'BarChartOutlined', label: '📉', search: 'bar chart graph' },
    { value: 'LineChartOutlined', label: '📊', search: 'line chart graph' },
    { value: 'CalculatorOutlined', label: '🧮', search: 'calculator math' },
    { value: 'CalendarOutlined', label: '📅', search: 'calendar date schedule' },
    { value: 'ClockCircleOutlined', label: '🕐', search: 'clock time' },
    { value: 'BellOutlined', label: '🔔', search: 'bell notification alert' },
    { value: 'NotificationOutlined', label: '🔔', search: 'notification alert bell' },
    { value: 'MailOutlined', label: '📧', search: 'mail email message' },
    { value: 'MessageOutlined', label: '💬', search: 'message chat text' },
    { value: 'CommentOutlined', label: '💭', search: 'comment note feedback' },
    { value: 'TeamOutlined', label: '👥', search: 'team group people' },
    { value: 'UserOutlined', label: '👤', search: 'user person profile' },
    { value: 'IdcardOutlined', label: '🪪', search: 'id card identity' },
    { value: 'ContactsOutlined', label: '📇', search: 'contacts address book' },
    { value: 'FileOutlined', label: '📄', search: 'file document' },
    { value: 'FolderOutlined', label: '📁', search: 'folder directory' },
    { value: 'SaveOutlined', label: '💾', search: 'save disk storage' },
    { value: 'PrinterOutlined', label: '🖨️', search: 'printer print' },
    { value: 'ShoppingOutlined', label: '🛍️', search: 'shopping bags purchase' },
    { value: 'AccountBookOutlined', label: '📒', search: 'account book ledger expense' },
    { value: 'TransactionOutlined', label: '🔄', search: 'transaction exchange transfer' },
    { value: 'PayCircleOutlined', label: '💸', search: 'pay payment money' },
    { value: 'MoneyCollectOutlined', label: '💲', search: 'money collect income' },
    { value: 'PropertySafetyOutlined', label: '🏡', search: 'property safety home' },
    { value: 'InsuranceOutlined', label: '🛡️', search: 'insurance protect coverage' },
    { value: 'RedEnvelopeOutlined', label: '🧧', search: 'red envelope gift money' },
    { value: 'StockOutlined', label: '📈', search: 'stock market investment' },
    { value: 'GoldFilled', label: '🥇', search: 'gold precious metal' },
    { value: 'PercentageOutlined', label: '💯', search: 'percentage discount sale' },
    { value: 'RiseOutlined', label: '📈', search: 'rise increase profit' },
    { value: 'FallOutlined', label: '📉', search: 'fall decrease loss' },
    { value: 'SwapOutlined', label: '🔁', search: 'swap exchange trade' },
    { value: 'SyncOutlined', label: '🔄', search: 'sync refresh update' },
    { value: 'AuditOutlined', label: '📋', search: 'audit review check' },
    { value: 'ReconciliationOutlined', label: '📊', search: 'reconciliation balance report' },
    { value: 'ContainerOutlined', label: '📦', search: 'container box package' },
    { value: 'DatabaseOutlined', label: '🗄️', search: 'database storage data' },
    { value: 'BuildOutlined', label: '🔨', search: 'build construction work' },
    { value: 'AppleOutlined', label: '🍎', search: 'apple fruit food' },
    { value: 'AndroidOutlined', label: '🤖', search: 'android robot tech' },
    { value: 'WindowsOutlined', label: '🪟', search: 'windows computer' },
    { value: 'ChromeOutlined', label: '🌐', search: 'chrome browser web' },
    { value: 'GithubOutlined', label: '🐙', search: 'github code dev' },
    { value: 'TwitterOutlined', label: '🐦', search: 'twitter social media' },
    { value: 'FacebookOutlined', label: '👍', search: 'facebook social media' },
    { value: 'InstagramOutlined', label: '📸', search: 'instagram social photo' },
    { value: 'LinkedinOutlined', label: '💼', search: 'linkedin professional work' },
    { value: 'YoutubeOutlined', label: '📺', search: 'youtube video media' },
    { value: 'SkypeOutlined', label: '💬', search: 'skype call chat' },
    { value: 'SlackOutlined', label: '💬', search: 'slack work chat' },
    { value: 'GoogleOutlined', label: '🔍', search: 'google search' },
    { value: 'AmazonOutlined', label: '📦', search: 'amazon shopping delivery' },
    { value: 'WechatOutlined', label: '💬', search: 'wechat chat message' },
    { value: 'AlipayOutlined', label: '💳', search: 'alipay payment money' },
    { value: 'TaobaoOutlined', label: '🛒', search: 'taobao shopping buy' },
    { value: 'ZhihuOutlined', label: '❓', search: 'zhihu question knowledge' },
    { value: 'Html5Outlined', label: '🌐', search: 'html web code' },
    { value: 'DropboxOutlined', label: '📦', search: 'dropbox storage cloud' },
    { value: 'RedditOutlined', label: '🤖', search: 'reddit social forum' },
    { value: 'MediumOutlined', label: '📝', search: 'medium blog writing' },
    { value: 'GitlabOutlined', label: '🦊', search: 'gitlab code dev' },
    { value: 'DingtalkOutlined', label: '💼', search: 'dingtalk work chat' },
    { value: 'BehanceOutlined', label: '🎨', search: 'behance design art' },
    { value: 'CodepenOutlined', label: '💻', search: 'codepen code dev' },
    { value: 'CodeSandboxOutlined', label: '📦', search: 'codesandbox code dev' },
    { value: 'DribbbleOutlined', label: '🏀', search: 'dribbble design art' },
    { value: 'SketchOutlined', label: '💎', search: 'sketch design ui' },
    { value: 'AntDesignOutlined', label: '🐜', search: 'antd design ui' },
    { value: 'PizzaOutlined', label: '🍕', search: 'pizza food eat' },
    { value: 'BurgerOutlined', label: '🍔', search: 'burger food eat' },
    { value: 'IceCreamOutlined', label: '🍦', search: 'ice cream dessert' },
    { value: 'CakeOutlined', label: '🎂', search: 'cake dessert birthday' },
    { value: 'BeerOutlined', label: '🍺', search: 'beer drink alcohol' },
    { value: 'WineOutlined', label: '🍷', search: 'wine drink alcohol' },
    { value: 'TeaOutlined', label: '🍵', search: 'tea drink hot' },
    { value: 'SandwichOutlined', label: '🥪', search: 'sandwich food lunch' },
    { value: 'SaladOutlined', label: '🥗', search: 'salad food healthy' },
    { value: 'SushiOutlined', label: '🍣', search: 'sushi food japanese' },
    { value: 'TacoOutlined', label: '🌮', search: 'taco food mexican' },
    { value: 'NoodleOutlined', label: '🍜', search: 'noodle food asian' },
    { value: 'RiceOutlined', label: '🍚', search: 'rice food asian' },
    { value: 'BreadOutlined', label: '🍞', search: 'bread food bakery' },
    { value: 'EggOutlined', label: '🥚', search: 'egg food breakfast' },
    { value: 'CheeseOutlined', label: '🧀', search: 'cheese food dairy' },
    { value: 'BaconOutlined', label: '🥓', search: 'bacon food breakfast' },
    { value: 'FruitOutlined', label: '🍇', search: 'fruit food healthy' },
    { value: 'VegetableOutlined', label: '🥦', search: 'vegetable food healthy' },
    { value: 'CarrotOutlined', label: '🥕', search: 'carrot vegetable food' },
    { value: 'PotatoOutlined', label: '🥔', search: 'potato vegetable food' },
    { value: 'TomatoOutlined', label: '🍅', search: 'tomato vegetable food' },
    { value: 'CornOutlined', label: '🌽', search: 'corn vegetable food' },
    { value: 'PepperOutlined', label: '🌶️', search: 'pepper spicy food' },
    { value: 'MushroomOutlined', label: '🍄', search: 'mushroom vegetable food' },
    { value: 'PeanutOutlined', label: '🥜', search: 'peanut nut food' },
    { value: 'AvocadoOutlined', label: '🥑', search: 'avocado fruit food' },
    { value: 'BananaOutlined', label: '🍌', search: 'banana fruit food' },
    { value: 'OrangeOutlined', label: '🍊', search: 'orange fruit food' },
    { value: 'StrawberryOutlined', label: '🍓', search: 'strawberry fruit food' },
    { value: 'WatermelonOutlined', label: '🍉', search: 'watermelon fruit food' },
    { value: 'GrapesOutlined', label: '🍇', search: 'grapes fruit food' },
    { value: 'CherryOutlined', label: '🍒', search: 'cherry fruit food' },
    { value: 'PeachOutlined', label: '🍑', search: 'peach fruit food' },
    { value: 'MangoOutlined', label: '🥭', search: 'mango fruit food' },
    { value: 'PineappleOutlined', label: '🍍', search: 'pineapple fruit food' },
    { value: 'CoconutOutlined', label: '🥥', search: 'coconut fruit food' },
    { value: 'KiwiOutlined', label: '🥝', search: 'kiwi fruit food' },
    { value: 'LemonOutlined', label: '🍋', search: 'lemon fruit food' },
    { value: 'PearOutlined', label: '🍐', search: 'pear fruit food' },
    { value: 'DogOutlined', label: '🐕', search: 'dog pet animal' },
    { value: 'CatOutlined', label: '🐈', search: 'cat pet animal' },
    { value: 'FishOutlined', label: '🐟', search: 'fish pet animal' },
    { value: 'BirdOutlined', label: '🐦', search: 'bird pet animal' },
    { value: 'TreeOutlined', label: '🌳', search: 'tree nature plant' },
    { value: 'FlowerOutlined', label: '🌸', search: 'flower nature plant' },
    { value: 'SunOutlined', label: '☀️', search: 'sun weather sunny' },
    { value: 'MoonOutlined', label: '🌙', search: 'moon night weather' },
    { value: 'RainOutlined', label: '🌧️', search: 'rain weather' },
    { value: 'SnowOutlined', label: '❄️', search: 'snow winter weather' },
    { value: 'UmbrellaOutlined', label: '☂️', search: 'umbrella rain weather' },
    { value: 'PlaneOutlined', label: '✈️', search: 'plane travel flight' },
    { value: 'TrainOutlined', label: '🚆', search: 'train travel transport' },
    { value: 'BusOutlined', label: '🚌', search: 'bus travel transport' },
    { value: 'TaxiOutlined', label: '🚕', search: 'taxi travel transport' },
    { value: 'BikeOutlined', label: '🚲', search: 'bike bicycle transport' },
    { value: 'MotorcycleOutlined', label: '🏍️', search: 'motorcycle transport' },
    { value: 'ShipOutlined', label: '🚢', search: 'ship boat travel' },
    { value: 'AnchorOutlined', label: '⚓', search: 'anchor ship boat' },
    { value: 'GymOutlined', label: '🏋️', search: 'gym fitness exercise' },
    { value: 'RunningOutlined', label: '🏃', search: 'running exercise fitness' },
    { value: 'SwimmingOutlined', label: '🏊', search: 'swimming exercise fitness' },
    { value: 'SoccerOutlined', label: '⚽', search: 'soccer football sport' },
    { value: 'BasketballOutlined', label: '🏀', search: 'basketball sport' },
    { value: 'TennisOutlined', label: '🎾', search: 'tennis sport' },
    { value: 'BaseballOutlined', label: '⚾', search: 'baseball sport' },
    { value: 'GolfOutlined', label: '⛳', search: 'golf sport' },
    { value: 'GameOutlined', label: '🎮', search: 'game gaming entertainment' },
    { value: 'MusicOutlined', label: '🎵', search: 'music entertainment' },
    { value: 'MovieOutlined', label: '🎬', search: 'movie film entertainment' },
    { value: 'TheaterOutlined', label: '🎭', search: 'theater drama entertainment' },
    { value: 'PaintOutlined', label: '🎨', search: 'paint art creative' },
    { value: 'BrushOutlined', label: '🖌️', search: 'brush paint art' },
    { value: 'PencilOutlined', label: '✏️', search: 'pencil write draw' },
    { value: 'PenOutlined', label: '🖊️', search: 'pen write' },
    { value: 'NotebookOutlined', label: '📓', search: 'notebook note write' },
    { value: 'GlassesOutlined', label: '👓', search: 'glasses eyewear' },
    { value: 'WatchOutlined', label: '⌚', search: 'watch time clock' },
    { value: 'RingOutlined', label: '💍', search: 'ring jewelry' },
    { value: 'DiamondOutlined', label: '💎', search: 'diamond jewelry gem' },
    { value: 'BagOutlined', label: '👜', search: 'bag purse shopping' },
    { value: 'ShoesOutlined', label: '👟', search: 'shoes footwear fashion' },
    { value: 'HatOutlined', label: '🎩', search: 'hat fashion clothing' },
    { value: 'TieOutlined', label: '👔', search: 'tie fashion clothing' },
    { value: 'DressOutlined', label: '👗', search: 'dress fashion clothing' },
    { value: 'GasStationOutlined', label: '⛽', search: 'gas station fuel car' },
    { value: 'ParkingOutlined', label: '🅿️', search: 'parking car vehicle' },
    { value: 'LaundryOutlined', label: '🧺', search: 'laundry cleaning clothes' },
    { value: 'CleaningOutlined', label: '🧹', search: 'cleaning housework' },
    { value: 'PetOutlined', label: '🐾', search: 'pet animal care' },
    { value: 'VetOutlined', label: '🏥', search: 'vet veterinary pet' },
    { value: 'DentistOutlined', label: '🦷', search: 'dentist dental health' },
    { value: 'PharmacyOutlined', label: '💊', search: 'pharmacy medicine drug' },
    { value: 'HospitalOutlined', label: '🏥', search: 'hospital medical health' },
    { value: 'AmbulanceOutlined', label: '🚑', search: 'ambulance emergency medical' },
    { value: 'ChildcareOutlined', label: '👶', search: 'childcare baby kids' },
    { value: 'SchoolOutlined', label: '🏫', search: 'school education learning' },
    { value: 'UniversityOutlined', label: '🎓', search: 'university college education' },
    { value: 'LibraryOutlined', label: '📚', search: 'library books study' },
    { value: 'CourseOutlined', label: '📖', search: 'course class learning' },
    { value: 'TuitionOutlined', label: '💰', search: 'tuition fee education' },
    { value: 'MarketOutlined', label: '🏪', search: 'market store shopping' },
    { value: 'SupermarketOutlined', label: '🏬', search: 'supermarket shopping' },
    { value: 'MallOutlined', label: '🏢', search: 'mall shopping center' },
    { value: 'OnlineShoppingOutlined', label: '📱', search: 'online shopping ecommerce' },
    { value: 'DeliveryOutlined', label: '📦', search: 'delivery shipping package' },
    { value: 'FastFoodOutlined', label: '🍔', search: 'fast food burger' },
    { value: 'CafeOutlined', label: '☕', search: 'cafe coffee shop' },
    { value: 'BarOutlined', label: '🍺', search: 'bar drinks alcohol' },
    { value: 'BreakfastOutlined', label: '🍳', search: 'breakfast morning food' },
    { value: 'LunchOutlined', label: '🍱', search: 'lunch food meal' },
    { value: 'DinnerOutlined', label: '🍽️', search: 'dinner food meal' },
    { value: 'SnackOutlined', label: '🍿', search: 'snack food' },
    { value: 'DessertOutlined', label: '🍰', search: 'dessert sweet cake' },
    { value: 'ElectricityOutlined', label: '💡', search: 'electricity power bill' },
    { value: 'WaterOutlined', label: '💧', search: 'water bill utility' },
    { value: 'InternetOutlined', label: '🌐', search: 'internet wifi bill' },
    { value: 'CableOutlined', label: '📺', search: 'cable tv subscription' },
    { value: 'StreamingOutlined', label: '📺', search: 'streaming netflix subscription' },
    { value: 'MobileOutlined', label: '📱', search: 'mobile phone bill' },
    { value: 'RentOutlined', label: '🏠', search: 'rent housing payment' },
    { value: 'MortgageOutlined', label: '🏡', search: 'mortgage home loan' },
    { value: 'PropertyTaxOutlined', label: '🏘️', search: 'property tax home' },
    { value: 'HOAOutlined', label: '🏘️', search: 'hoa fee community' },
    { value: 'FurnitureOutlined', label: '🛋️', search: 'furniture home decor' },
    { value: 'ApplianceOutlined', label: '🔌', search: 'appliance home electronics' },
    { value: 'GardenOutlined', label: '🌱', search: 'garden yard plants' },
    { value: 'LawnOutlined', label: '🌿', search: 'lawn yard maintenance' },
    { value: 'TaxOutlined', label: '📋', search: 'tax payment government' },
    { value: 'FineOutlined', label: '🚫', search: 'fine penalty fee' },
    { value: 'TicketOutlined', label: '🎫', search: 'ticket event entertainment' },
    { value: 'MembershipOutlined', label: '🎟️', search: 'membership subscription fee' },
    { value: 'CharityOutlined', label: '❤️', search: 'charity donation giving' },

    // Extra food & drink
    { value: 'HotdogOutlined', label: '🌭', search: 'hotdog food eat' },
    { value: 'FriesOutlined', label: '🍟', search: 'fries fast food' },
    { value: 'PancakeOutlined', label: '🥞', search: 'pancake breakfast food' },
    { value: 'WaffleOutlined', label: '🧇', search: 'waffle breakfast food' },
    { value: 'DonutOutlined', label: '🍩', search: 'donut dessert food' },
    { value: 'CookieOutlined', label: '🍪', search: 'cookie dessert food' },
    { value: 'ChocolateOutlined', label: '🍫', search: 'chocolate candy sweet' },
    { value: 'CandyOutlined', label: '🍬', search: 'candy sweet snack' },
    { value: 'LollipopOutlined', label: '🍭', search: 'lollipop candy sweet' },
    { value: 'HoneyOutlined', label: '🍯', search: 'honey food sweet' },
    { value: 'MilkOutlined', label: '🥛', search: 'milk drink dairy' },
    { value: 'JuiceOutlined', label: '🧃', search: 'juice drink fruit' },
    { value: 'SodaOutlined', label: '🥤', search: 'soda drink soft' },
    { value: 'BubbleTeaOutlined', label: '🧋', search: 'bubble tea drink boba' },
    { value: 'CocktailOutlined', label: '🍸', search: 'cocktail drink alcohol' },
    { value: 'TropicalDrinkOutlined', label: '🍹', search: 'tropical drink cocktail' },
    { value: 'ChampagneOutlined', label: '🍾', search: 'champagne drink celebrate' },
    { value: 'SoupOutlined', label: '🍲', search: 'soup food hot pot' },
    { value: 'StewOutlined', label: '🥘', search: 'stew food casserole' },
    { value: 'BentoOutlined', label: '🍱', search: 'bento lunch japanese' },
    { value: 'DumplingsOutlined', label: '🥟', search: 'dumplings food asian' },
    { value: 'FalafelOutlined', label: '🧆', search: 'falafel food middle eastern' },
    { value: 'OystersOutlined', label: '🦪', search: 'oysters seafood food' },
    { value: 'ShrimpOutlined', label: '🍤', search: 'shrimp seafood food' },
    { value: 'CrabOutlined', label: '🦀', search: 'crab seafood food' },
    { value: 'LobsterOutlined', label: '🦞', search: 'lobster seafood food' },
    { value: 'SteakOutlined', label: '🥩', search: 'steak meat food' },
    { value: 'ChickenOutlined', label: '🍗', search: 'chicken meat food' },
    { value: 'MeatOnBoneOutlined', label: '🍖', search: 'meat food protein' },

    // Health & fitness
    { value: 'YogaOutlined', label: '🧘', search: 'yoga fitness wellness' },
    { value: 'CyclingOutlined', label: '🚴', search: 'cycling fitness exercise' },
    { value: 'HikingOutlined', label: '🥾', search: 'hiking outdoor fitness' },
    { value: 'ClimbingOutlined', label: '🧗', search: 'climbing sport fitness' },
    { value: 'SkiingOutlined', label: '⛷️', search: 'skiing winter sport' },
    { value: 'SnowboardingOutlined', label: '🏂', search: 'snowboarding winter sport' },
    { value: 'SurfingOutlined', label: '🏄', search: 'surfing water sport' },
    { value: 'RowingOutlined', label: '🚣', search: 'rowing water sport fitness' },
    { value: 'BoxingOutlined', label: '🥊', search: 'boxing sport fitness' },
    { value: 'MartialArtsOutlined', label: '🥋', search: 'martial arts sport fitness' },
    { value: 'MeditationOutlined', label: '🧠', search: 'meditation mindfulness health' },
    { value: 'SpaOutlined', label: '💆', search: 'spa relaxation wellness' },
    { value: 'MassageOutlined', label: '💆', search: 'massage relaxation wellness' },
    { value: 'NailsOutlined', label: '💅', search: 'nails beauty salon' },
    { value: 'HaircutOutlined', label: '💇', search: 'haircut salon beauty' },
    { value: 'VitaminsOutlined', label: '💊', search: 'vitamins supplements health' },
    { value: 'BloodTestOutlined', label: '🩸', search: 'blood test medical health' },
    { value: 'BandageOutlined', label: '🩹', search: 'bandage first aid health' },
    { value: 'StethoscopeOutlined', label: '🩺', search: 'stethoscope doctor health' },
    { value: 'XRayOutlined', label: '🩻', search: 'xray medical imaging' },

    // Home & living
    { value: 'SofaOutlined', label: '🛋️', search: 'sofa couch furniture' },
    { value: 'BedOutlined', label: '🛏️', search: 'bed furniture bedroom' },
    { value: 'BathtubOutlined', label: '🛁', search: 'bathtub bathroom home' },
    { value: 'ShowerOutlined', label: '🚿', search: 'shower bathroom home' },
    { value: 'ToiletOutlined', label: '🚽', search: 'toilet bathroom home' },
    { value: 'MicrowaveOutlined', label: '📦', search: 'microwave appliance kitchen' },
    { value: 'RefrigeratorOutlined', label: '🧊', search: 'refrigerator appliance kitchen' },
    { value: 'WashingMachineOutlined', label: '🫧', search: 'washing machine appliance laundry' },
    { value: 'VacuumOutlined', label: '🧹', search: 'vacuum cleaning home' },
    { value: 'MopOutlined', label: '🧹', search: 'mop cleaning floor' },
    { value: 'BroomOutlined', label: '🧹', search: 'broom cleaning sweep' },
    { value: 'SoapOutlined', label: '🧼', search: 'soap cleaning hygiene' },
    { value: 'ToothbrushOutlined', label: '🪥', search: 'toothbrush hygiene dental' },
    { value: 'RazorOutlined', label: '🪒', search: 'razor shaving grooming' },
    { value: 'MirrorOutlined', label: '🪞', search: 'mirror bathroom home' },
    { value: 'PaintBrushHomeOutlined', label: '🖌️', search: 'paint home renovation' },
    { value: 'HammerOutlined', label: '🔨', search: 'hammer tool repair home' },
    { value: 'ScrewdriverOutlined', label: '🪛', search: 'screwdriver tool repair' },
    { value: 'WrenchOutlined', label: '🔧', search: 'wrench tool plumbing' },
    { value: 'PlumbingOutlined', label: '🚰', search: 'plumbing water faucet' },
    { value: 'LightbulbOutlined', label: '💡', search: 'lightbulb electricity home' },
    { value: 'ExtensionCordOutlined', label: '🔌', search: 'extension cord electricity home' },
    { value: 'SecurityCameraOutlined', label: '📹', search: 'security camera home safety' },
    { value: 'DoorbellOutlined', label: '🔔', search: 'doorbell home entry' },
    { value: 'MailboxOutlined', label: '📫', search: 'mailbox mail home' },
    { value: 'FenceOutlined', label: '🌿', search: 'fence yard home exterior' },
    { value: 'PoolOutlined', label: '🏊', search: 'pool swimming home' },

    // Travel & transport
    { value: 'HotelOutlined', label: '🏨', search: 'hotel accommodation travel' },
    { value: 'CampingOutlined', label: '⛺', search: 'camping outdoor travel' },
    { value: 'BeachOutlined', label: '🏖️', search: 'beach vacation travel' },
    { value: 'MountainOutlined', label: '⛰️', search: 'mountain hiking travel' },
    { value: 'IslandOutlined', label: '🏝️', search: 'island vacation travel' },
    { value: 'LuggageOutlined', label: '🧳', search: 'luggage travel bag' },
    { value: 'PassportOutlined', label: '🛂', search: 'passport travel document' },
    { value: 'MapOutlined', label: '🗺️', search: 'map travel navigation' },
    { value: 'CompassOutlined', label: '🧭', search: 'compass navigation travel' },
    { value: 'TollOutlined', label: '🛣️', search: 'toll road highway transport' },
    { value: 'CarWashOutlined', label: '🚗', search: 'car wash vehicle cleaning' },
    { value: 'CarRepairOutlined', label: '🔧', search: 'car repair mechanic vehicle' },
    { value: 'TireOutlined', label: '🔄', search: 'tire vehicle maintenance' },
    { value: 'OilChangeOutlined', label: '🛢️', search: 'oil change vehicle maintenance' },
    { value: 'RegistrationOutlined', label: '📋', search: 'car registration vehicle fee' },
    { value: 'RideShareOutlined', label: '🚗', search: 'rideshare uber lyft transport' },
    { value: 'SubwayOutlined', label: '🚇', search: 'subway metro transport' },
    { value: 'TramOutlined', label: '🚊', search: 'tram transport city' },
    { value: 'FerryOutlined', label: '⛴️', search: 'ferry boat water transport' },
    { value: 'HelicopterOutlined', label: '🚁', search: 'helicopter air transport' },
    { value: 'ScooterOutlined', label: '🛴', search: 'scooter transport electric' },

    // Finance & money
    { value: 'SavingsOutlined', label: '🏦', search: 'savings bank account' },
    { value: 'InvestmentOutlined', label: '📈', search: 'investment portfolio finance' },
    { value: 'CryptoOutlined', label: '₿', search: 'crypto bitcoin blockchain' },
    { value: 'LoanOutlined', label: '💸', search: 'loan debt borrow' },
    { value: 'InterestOutlined', label: '💹', search: 'interest rate finance' },
    { value: 'DividendOutlined', label: '💰', search: 'dividend income finance' },
    { value: 'BudgetOutlined', label: '📊', search: 'budget finance plan' },
    { value: 'ExpenseOutlined', label: '🧾', search: 'expense receipt bill' },
    { value: 'ReceiptOutlined', label: '🧾', search: 'receipt purchase expense' },
    { value: 'InvoiceOutlined', label: '📄', search: 'invoice bill payment' },
    { value: 'RefundOutlined', label: '↩️', search: 'refund return money' },
    { value: 'CashbackOutlined', label: '💵', search: 'cashback reward money' },
    { value: 'ATMOutlined', label: '🏧', search: 'atm cash withdraw' },
    { value: 'CheckOutlined', label: '📝', search: 'check payment bank' },
    { value: 'WireTransferOutlined', label: '🔁', search: 'wire transfer bank payment' },
    { value: 'PayPalOutlined', label: '💳', search: 'paypal payment online' },
    { value: 'VenmoOutlined', label: '💸', search: 'venmo payment split' },
    { value: 'ZelleOutlined', label: '💳', search: 'zelle payment bank' },

    // Kids & family
    { value: 'BabyBottleOutlined', label: '🍼', search: 'baby bottle infant' },
    { value: 'DiaperOutlined', label: '👶', search: 'diaper baby infant' },
    { value: 'ToyOutlined', label: '🧸', search: 'toy kids play' },
    { value: 'BlocksOutlined', label: '🧩', search: 'blocks puzzle kids toy' },
    { value: 'BalloonOutlined', label: '🎈', search: 'balloon party kids' },
    { value: 'KiteOutlined', label: '🪁', search: 'kite outdoor kids play' },
    { value: 'BikeKidsOutlined', label: '🚲', search: 'bike kids outdoor' },
    { value: 'SwingOutlined', label: '🛝', search: 'swing playground kids' },
    { value: 'BackpackOutlined', label: '🎒', search: 'backpack school kids' },
    { value: 'CrayonOutlined', label: '🖍️', search: 'crayon draw kids art' },
    { value: 'PuppetOutlined', label: '🪆', search: 'puppet toy kids' },
    { value: 'YoYoOutlined', label: '🪀', search: 'yoyo toy kids play' },

    // Entertainment & hobbies
    { value: 'ConcertOutlined', label: '🎤', search: 'concert music live' },
    { value: 'FestivalOutlined', label: '🎪', search: 'festival event outdoor' },
    { value: 'CircusOutlined', label: '🎡', search: 'circus fair amusement' },
    { value: 'AmusementParkOutlined', label: '🎢', search: 'amusement park ride fun' },
    { value: 'ZooOutlined', label: '🦁', search: 'zoo animals entertainment' },
    { value: 'AquariumOutlined', label: '🐠', search: 'aquarium fish entertainment' },
    { value: 'MuseumOutlined', label: '🏛️', search: 'museum art history' },
    { value: 'GalleryOutlined', label: '🖼️', search: 'gallery art exhibition' },
    { value: 'BowlingOutlined', label: '🎳', search: 'bowling sport entertainment' },
    { value: 'ArcheryOutlined', label: '🏹', search: 'archery sport hobby' },
    { value: 'FishingOutlined', label: '🎣', search: 'fishing hobby outdoor' },
    { value: 'HuntingOutlined', label: '🦌', search: 'hunting outdoor hobby' },
    { value: 'ChessOutlined', label: '♟️', search: 'chess board game hobby' },
    { value: 'CardGameOutlined', label: '🃏', search: 'card game hobby' },
    { value: 'DiceOutlined', label: '🎲', search: 'dice game hobby' },
    { value: 'PuzzleOutlined', label: '🧩', search: 'puzzle game hobby' },
    { value: 'VROutlined', label: '🥽', search: 'vr virtual reality gaming' },
    { value: 'ControllerOutlined', label: '🕹️', search: 'controller gaming hobby' },
    { value: 'BookClubOutlined', label: '📚', search: 'book club reading hobby' },
    { value: 'PotteryOutlined', label: '🫙', search: 'pottery craft hobby art' },
    { value: 'KnittingOutlined', label: '🧶', search: 'knitting craft hobby' },
    { value: 'SewingOutlined', label: '🧵', search: 'sewing craft hobby' },
    { value: 'WoodworkingOutlined', label: '🪵', search: 'woodworking craft hobby' },
    { value: 'GardeningOutlined', label: '🌻', search: 'gardening hobby outdoor' },
    { value: 'PhotographyOutlined', label: '📸', search: 'photography hobby art' },

    // Work & business
    { value: 'OfficeOutlined', label: '🏢', search: 'office work business' },
    { value: 'MeetingOutlined', label: '👔', search: 'meeting work business' },
    { value: 'LaptopOutlined', label: '💻', search: 'laptop computer work' },
    { value: 'MonitorOutlined', label: '🖥️', search: 'monitor computer work' },
    { value: 'KeyboardOutlined', label: '⌨️', search: 'keyboard computer work' },
    { value: 'MouseOutlined', label: '🖱️', search: 'mouse computer work' },
    { value: 'HeadsetOutlined', label: '🎧', search: 'headset work call' },
    { value: 'WebcamOutlined', label: '📷', search: 'webcam video call work' },
    { value: 'DeskOutlined', label: '🪑', search: 'desk chair office work' },
    { value: 'StationeryOutlined', label: '📎', search: 'stationery office supplies' },
    { value: 'ShredderOutlined', label: '📄', search: 'shredder office document' },
    { value: 'BusinessCardOutlined', label: '🪪', search: 'business card work' },
    { value: 'ConferenceOutlined', label: '🎙️', search: 'conference presentation work' },
    { value: 'TrainingOutlined', label: '📖', search: 'training development work' },
    { value: 'FreelanceOutlined', label: '🧑‍💻', search: 'freelance work contract' },
    { value: 'SalaryOutlined', label: '💰', search: 'salary income work pay' },
    { value: 'BonusOutlined', label: '🎁', search: 'bonus reward work' },
    { value: 'BusinessTripOutlined', label: '✈️', search: 'business trip travel work' },
    { value: 'NetworkingOutlined', label: '🤝', search: 'networking business connection' },
    { value: 'LicenseOutlined', label: '📜', search: 'license permit certification' },
    { value: 'SubscriptionOutlined', label: '🔄', search: 'subscription software service' },
    { value: 'HostingOutlined', label: '🌐', search: 'hosting server web' },
    { value: 'DomainOutlined', label: '🔗', search: 'domain web hosting' },
    { value: 'AdvertisingOutlined', label: '📣', search: 'advertising marketing business' },
    { value: 'PrintingOutlined', label: '🖨️', search: 'printing office document' },
    { value: 'ShippingOutlined', label: '📦', search: 'shipping business package' },
];


